import { render } from "./DashFooter.vue?vue&type=template&id=99f01330&scoped=true"
import script from "./DashFooter.vue?vue&type=script&lang=js"
export * from "./DashFooter.vue?vue&type=script&lang=js"

import "./DashFooter.vue?vue&type=style&index=0&id=99f01330&scoped=true&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f01330"],['__file',"src/components/ui/DashFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99f01330"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99f01330', __exports__)) {
    console.log('reload')
    api.reload('99f01330', __exports__)
  }
  
  module.hot.accept("./DashFooter.vue?vue&type=template&id=99f01330&scoped=true", () => {
    console.log('re-render')
    api.rerender('99f01330', render)
  })

}


export default __exports__